import { render } from "./FormInit.vue?vue&type=template&id=cdbdc872&scoped=true"
import script from "./FormInit.vue?vue&type=script&lang=js"
export * from "./FormInit.vue?vue&type=script&lang=js"

import "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css"
import "./FormInit.vue?vue&type=style&index=1&id=cdbdc872&lang=scss&scoped=true"

import exportComponent from "C:\\wamp2022\\www\\emotivapp\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdbdc872"]])

export default __exports__